import React, { FC } from "react";
import { Link } from "react-router-dom";
import SolutionOptionsModal from "./SolutionOptionsModal";
import CreateSolutionModal from "../Library/CreateSolutionModal";
import {
  SolutionClientType,
  SolutionType,
} from "../store/slices/settingsSlice";
import MyIcon from "../Common/MyIcon";
import EditIcon from "../../assets/icons/Icon_Library/application icons/general/edit.svg2";
import SearchIcon from "../../assets/icons/Icon_Library/application icons/general/search.svg2";

interface DetailsForSolutionModalsProps {
  solution: SolutionType;
  clientSolution?: SolutionClientType;
}

const DetailsForSolutionModals: FC<DetailsForSolutionModalsProps> = ({
  solution,
  clientSolution,
}) => {
  return (
    <div>
      <div className="py-2">
        <div className="fw-bold fs-3">Solution</div>
        <div className="p-3 rounded-3 bg-light mb-2">
          <div>
            <span className="me-2 fw-bold">Solution Name:</span>
            <span>{solution.Label} </span>
          </div>
          <div>
            <span className="me-2 fw-bold">Reference:</span>
            <span>{solution.Reference} </span>
          </div>
          <div>
            <span className="me-2 fw-bold">Description:</span>
            <span>{solution.Description} </span>
          </div>
          <div>
            <span className="me-2 fw-bold">Status:</span>
            <span>{solution.Status} </span>
          </div>
          <div>
            <span className="me-2 fw-bold">Version:</span>
            <span>{solution.Version}</span>
          </div>
          <div>
            <span className="me-2 fw-bold">Kind:</span>
            <span>{solution.Kind}</span>
          </div>
          <div>
            <span className="me-2 fw-bold">Created at:</span>
            <span>{new Date(solution.CreatedAt).toLocaleString()}</span>
          </div>
          <div>
            <span className="me-2 fw-bold">Updated at:</span>
            <span>{new Date(solution.UpdatedAt).toLocaleString()}</span>
          </div>
          <div>
            <span className="me-2 fw-bold">Email:</span>
            <span>{solution.Email}</span>
          </div>
        </div>
      </div>

      {/* <div className="py-2">
        <div className="fw-bold fs-3">Components </div>

        {solution.Components.map((comp, index) => (
          <div key={index} className="p-3 rounded-3 bg-light mb-2">
            <span className="me-2 fw-bold"> {comp.Item.Label}</span>
            <div>{comp.Description}</div>

            <div>
              <span className="me-2 fw-bold">Description:</span>
              <span>{comp.Item.Description}</span>
            </div>
            <div>
              <span>
                <div>
                  {Object.entries(
                    solution.Info.ActionBreakdownPerComponent[comp.ItemUuid] ||
                      {}
                  )
                    .slice()
                    .sort(([workflowKey, workflow]) =>
                      workflow.IsEntrypoint ? -1 : 1
                    )
                    .map(([workflowKey, workflow]) => (
                      <div
                        key={workflowKey}
                        className={`mt-2 p-2 border rounded-2 bg-white position-relative ${
                          workflow.IsEntrypoint ? "border-danger" : ""
                        }`}
                      >
                        {workflow.IsEntrypoint && (
                          <div className="position-absolute top-0 end-0 m-1 badge rounded-pill bg-danger">
                            First workflow{" "}
                          </div>
                        )}
                        <div>
                          <span className="me-2 fw-bold"> Workflow Name: </span>
                          <span>{workflow.WorkflowName}</span>
                        </div>

                        <div>
                          <span className="me-2 fw-bold">
                            Number of actions:{" "}
                          </span>
                          <span>{workflow.Total}</span>
                        </div>
                        <div>
                          <span className="me-2 fw-bold">Can Repeat: </span>
                          <span>{workflow.CanRepeat ? "Yes" : "No"}</span>
                        </div>
                      </div>
                    ))}
                </div>
              </span>
            </div>
          </div>
        ))}
      </div> */}
      {/* <div className="py-2">
        <div className="fw-bold fs-3">Client Solutions</div>
        {
          // Add client solution details here when available
            solution.ClientSolutions.map((clientSolution, index) => (
              <div key={index} className="p-3 rounded-3 bg-light mb-2">
                <div>
                  <span className="me-2 fw-bold">Client Solution Name:</span>
                  <span>{clientSolution.SolutionName}</span>
                </div>
                <div>
                  <span className="me-2 fw-bold">Client Solution ID:</span>
                  <span>{clientSolution.SolutionUuid}</span>
                </div>
                <div>
                  <span className="me-2 fw-bold">Client ID:</span>
                  <span>{clientSolution.ClientId}</span>
                </div>
                <div>
                  <span className="me-2 fw-bold">Email:</span>
                  <span>{clientSolution.Email}</span>
                </div>
                <div>
                  <span className="me-2 fw-bold">Status:</span>
                  <span>{clientSolution.Status}</span>
                </div>
                <div>
                  <span className="me-2 fw-bold">Was deployed:</span>
                  <span>
                    {clientSolution.WasDeployed === "true" ? "Yes" : "No"}
                  </span>
                </div>
                // Add more fields as necessary
              </div>
            ))
          ) : (
            <div>No client solutions available.</div>
          )
        }
      </div> */}
      <div className="d-flex justify-content-end align-items-center mt-3 gap-3">
        <Link to={`/library/solutions/${solution.Uuid}`}>
          <div className="d-flex align-items-center">
            <MyIcon Icon={SearchIcon} width={20} className="rounded-3" />
            <span className="ms-2 fw-bold text-navy">View Details</span>
          </div>
        </Link>
        <SolutionOptionsModal
          solution={solution}
          clientSolution={clientSolution}
        />
        {!clientSolution && (
          <Link to={`/library/solutions/${solution.Uuid}/edit`}>
            <div className="d-flex align-items-center">
              <MyIcon Icon={EditIcon} width={20} className="rounded-3" />
              <span className="ms-2 fw-bold text-navy">Edit Solution</span>
            </div>
          </Link>
        )}
      </div>
    </div>
  );
};

export default DetailsForSolutionModals;
